import Reveal from "@/components/Reveal";
import { CAREER_ROLES, IMG } from "@/data/content";
import { ArrowUpRight } from "lucide-react";
import { trackEvent } from "@/lib/tracking";

export default function Careers() {
  return (
    <section id="careers" data-testid="careers-section" className="bg-rc-bg py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal trackLabel="careers" className="order-2 lg:order-1">
          <div className="font-mono text-rc-red text-xs uppercase tracking-[0.3em] mb-5">06 — Careers</div>
          <h2 className="font-heading font-black text-rc-blue leading-[0.95] text-[clamp(2rem,4.5vw,3.5rem)] tracking-tight">
            Build more than roads. Build a career.
          </h2>
          <p className="mt-6 text-rc-brown text-lg leading-relaxed">
            Whether you're experienced or just starting out, we offer hands-on training, mentorship and clear paths for
            advancement across heavy highway and asphalt construction.
          </p>

          <div className="mt-7 flex flex-wrap gap-2">
            {CAREER_ROLES.map((r) => (
              <span key={r} className="text-xs font-medium text-rc-charcoal border border-black/15 px-3 py-1.5">
                {r}
              </span>
            ))}
          </div>

          <a
            href="https://careers.rangerconstruction.com/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="careers-apply-button"
            onClick={() => trackEvent("cta_click", { label: "careers_apply" })}
            className="mt-9 inline-flex items-center gap-2 bg-rc-charcoal text-white px-8 py-4 rounded-full font-bold uppercase tracking-[0.15em] text-sm hover:bg-rc-red transition-colors"
          >
            Apply Online <ArrowUpRight size={18} />
          </a>
        </Reveal>

        <Reveal delay={0.1} className="order-1 lg:order-2 grid grid-cols-2 gap-4">
          <img src={IMG.careers2} alt="Ranger paving crew working at night" className="w-full h-72 object-cover mt-8" />
          <img src={IMG.careers1} alt="Ranger equipment operator at a paving machine" className="w-full h-72 object-cover object-[25%_50%]" />
        </Reveal>
      </div>
    </section>
  );
}
